// Copyright ©️ 2026 eVolve MEP, LLC

import { useMemo } from 'react';

import type { RenderableSpool } from 'components/Autodesk/extensions/SpoolsExtension/types';
import { useAutodeskExtensionStoreSnapshot } from 'components/Autodesk/useAutodeskExtensionStore';
import { strongEntries } from 'helpers/strongEntries';

/** Returns the names of the currently isolated spools. */
export const useCurrentIsolatedSpools = (): [RenderableSpool['name'], RenderableSpool][] => {
  const { isolatedDbIds } = useAutodeskExtensionStoreSnapshot('apsViewer');
  const spools = useAutodeskExtensionStoreSnapshot('spools');
  // Note that we mark a spool as isolated if any of its objects are isolated.
  // We're assuming here that no objects are shared between spools. If that assumption is wrong, we may need to change this logic.
  return useMemo(
    () =>
      strongEntries(spools ?? {}).filter(([, spool]) => spool.objects.some(({ dbId }) => isolatedDbIds.includes(dbId))),
    [spools, isolatedDbIds],
  );
};
